import { VideoModalComponent } from './video-modal/video-modal.component';
import { ExcludePipe } from './shared/exclude.pipe';
import { CustomScrollbarComponent } from './shared/custom-scrollbar/custom-scrollbar.component';
import { LocalizationGuard } from './localization-guard.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageComponent } from './page/page.component';
import { LoginComponent } from './login/login.component';
import { SelectorComponent } from './selector/selector.component';
import { TooltipComponent } from './shared/tooltip/tooltip.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { HomePageComponent } from './home-page/home-page.component';
import { OpenProjectComponent } from './open-project/open-project.component';
import { AnalyticsDirective } from './analytics.directive';
import { RoomComponent } from './page/room/room.component';
import { SystemComponent } from './page/system/system.component';
import { InternalUnitComponent } from './page/internal-unit/internal-unit.component';
import { SmartCameraComponent } from './page/smart-camera/smart-camera.component';
import { SmartThermoComponent } from './page/smart-thermo/smart-thermo.component';
import { FinishingComponent } from './page/finishing/finishing.component';
import { PackageComponent } from './page/package/package.component';
import { TimeComponent } from './page/time/time.component';
import { WhatToDoComponent } from './page/what-to-do/what-to-do.component';
import { HavingLivingLightComponent } from './page/having-living-light/having-living-light.component';
import { CoverConfiguratorComponent } from './page/cover-configurator/cover-configurator.component';
import { ExplanationComponent } from './page/explanation/explanation.component';
import { FrameShapeComponent } from './page/frame-shape/frame-shape.component';
import { SummaryComponent } from './page/summary/summary.component';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { SwitchComponent } from './page/switch/switch.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InfoButtonComponent } from './selector/info-button/info-button.component';
import { HighlightDirective } from './selector/svg-button-listner.directive';
import { NameTextComponent } from './shared/name-text/name-text.component';
import { LateralPanelComponent } from './page/lateral-panel/lateral-panel.component';
import { ThanksComponent } from './page/thanks/thanks.component';
import { PrivacyComponent } from './page/privacy/privacy.component';
import { TooltipDirective } from './shared/tooltip/tooltip.directive';
import { TransitionPageComponent } from './shared/transition-page/transition-page.component';
import { TooltipTogglerDirective } from './shared/tooltip/tooltip-toggler.directive';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { MaterialModule } from './material/material.module';
import { IMaskModule } from 'angular-imask';
import { IncludePipe } from './shared/include.pipe';
import { ShareProjectComponent } from './share-project/share-project.component';
import { SummaryViewComponent } from './page/summary-view/summary-view.component';
import { SendQuotationComponent } from './page/send-quotation/send-quotation.component';
import { FindInstallerComponent } from './page/find-installer/find-installer.component';
import { RejectComponent } from './reject/reject.component';

registerLocaleData(localeIt);

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    let hostName: string = window.location.hostname;
    let i18nURL: string = "../assets/i18n/";

    // tmp - duplicate code [dataprovider is not yet created]
    if (hostName.includes("demorooms") || hostName.includes("localhost")){
      i18nURL = "https://myhomeaddon.demorooms.com/i18n/";
    } else {
      i18nURL = "https://configuracasa.bticino.it/mysite/i18n/";
    }

    return new TranslateHttpLoader(http, i18nURL, '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    PageComponent,
    LoginComponent,
    SelectorComponent,
    TooltipComponent,
    SpinnerComponent,
    HomePageComponent,
    OpenProjectComponent,
    AnalyticsDirective,
    RoomComponent,
    SystemComponent,
    InternalUnitComponent,
    SmartCameraComponent,
    SmartThermoComponent,
    FinishingComponent,
    PackageComponent,
    TimeComponent,
    WhatToDoComponent,
    HavingLivingLightComponent,
    CoverConfiguratorComponent,
    ExplanationComponent,
    FrameShapeComponent,
    SummaryComponent,
    SwitchComponent,
    InfoButtonComponent,
    HighlightDirective,
    NameTextComponent,
    LateralPanelComponent,
    ThanksComponent,
    PrivacyComponent,
    TooltipDirective,
    TransitionPageComponent,
    CustomScrollbarComponent,
    TooltipTogglerDirective,
    ExcludePipe,
    VideoModalComponent,
    //CookiePolicyPopup,
    HeaderComponent,
    IncludePipe,
    ShareProjectComponent,
    SummaryViewComponent,
    FindInstallerComponent,
	  SendQuotationComponent,
   RejectComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IMaskModule
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: "it"
    },
    LocalizationGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
